'use strict';

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

void function () {
  if (window.swnLpLoaderInitiated === true) return;
  window.swnLpLoaderInitiated = true;
  var lpHost = '//widgets-lp.swaven.com',
      Ifr_URL = lpHost + '/assets/html/widget.html?v=1610037541319',
      TrkTid_URL = '//{{region}}-wtb-tag-api.swaven.com/trk/settid?swntid=',
      API_URL = '//wtb-api.swaven.com/api/conf/',
      API_AV_URL = '//{{region}}-wtb-api.swaven.com/api/search/products/',
      XMLHttpRequest_DONE = 4; // because sometimes this constant is redefined by a 3rd-party.

  void function entryPoint() {
    var IFRAME_ID_PREFIX = 'swn-lp-ifr-'; // Detects whether the browser can send objects through postMessage

    var postObj = true;

    try {
      window.postMessage({
        toString: function toString() {
          postObj = false;
        }
      }, '*');
    } catch (err) {} // https://gist.github.com/jed/982883


    function uuid(a) {
      return a ? (a ^ Math.random() * 16 >> a / 4).toString(16) : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, uuid);
    }

    var waitingPostMessage = {},
        widgetLocalData = {},
        btnWatcherItvs = {},
        popinStyleAdded = false,
        cookieInitiated = false,
        cookieCustomTxts = {};
    widgetLocalData.instancesData = {};
    widgetLocalData.originalConfs = {};
    widgetLocalData.clientCallback = null;
    widgetLocalData.urlConf = {};
    var i18nTxts = {
      en: {
        COOKIESTXT: 'By continuing to browse this site, you agree to our use of cookies for statistical purposes and to offer you an optimal service with personalised content according to your geographic location. For more information on managing your cookies, click on this link.',
        COOKIESOK: 'I accept',
        COOKIESMORE: 'More information',
        COOKIESLINK: 'http://www.swaven.com/cookie-policy/',
        IFRAMETITLE: 'Find a store'
      },
      fr: {
        COOKIESTXT: 'En poursuivant votre navigation sur ce site, vous acceptez l\'utilisation de cookies pour des fins statistiques et pour vous offrir un service optimal avec des contenus personnalis&eacute;s selon votre g&eacute;olocalisation. Pour plus d\'information sur la gestion de vos cookies, cliquez sur ce lien.',
        COOKIESOK: 'J\'accepte',
        COOKIESMORE: 'Plus d\'informations',
        COOKIESLINK: 'http://www.swaven.com/politique-des-cookies/',
        IFRAMETITLE: 'Trouver un magasin'
      },
      de: {
        COOKIESTXT: 'Durch die weitere Nutzung dieser Webseite stimmen Sie der Verwendung von Cookies zu. Wir nutzen Cookies f&uuml;r statistische Zwecke sowie um Ihnen einen optimalen Service mit personalisierten, standortgebundenen Inhalten zu bieten. F&uuml;r weitere Informationen bez&uuml;glich der Verwaltung Ihrer Cookies, klicken Sie bitte auf diesen Link.',
        COOKIESOK: 'Ich stimme zu',
        COOKIESMORE: 'Mehr Informationen',
        COOKIESLINK: 'http://www.swaven.com/cookie-richtlinien/',
        IFRAMETITLE: 'Finde ein Geschäft'
      },
      nl: {
        IFRAMETITLE: 'Vind een winkel'
      },
      es: {
        IFRAMETITLE: 'Encuentra una tienda'
      },
      zh: {
        IFRAMETITLE: '找到一家商店'
      },
      it: {
        IFRAMETITLE: 'Trova un negozio'
      },
      ja: {
        IFRAMETITLE: 'お店を探す'
      },
      pt: {
        IFRAMETITLE: 'Encontre uma loja'
      },
      ar: {
        IFRAMETITLE: 'ابحث عن متجر'
      },
      ru: {
        IFRAMETITLE: 'Найти магазин'
      },
      da: {
        IFRAMETITLE: 'Find en butik'
      },
      nn: {
        IFRAMETITLE: 'Finn en butikk'
      },
      el: {
        IFRAMETITLE: 'Βρες ένα κατάστημα'
      },
      sv: {
        IFRAMETITLE: 'Hitta en affär'
      },
      cs: {
        IFRAMETITLE: 'Najdi obchod'
      },
      ro: {
        IFRAMETITLE: 'Găsește un magazin'
      }
    };
    var pageId = uuid();
    var forceOpen = !!window.location.search.match(/wtbopen=1/i);
    var crispCompare = !!window.location.search.match(/crisp=1/i); // tring-to-JSON conversion
    // @param {Object} payload : payload to serialize

    function deserialize(payload) {
      if (postObj) return payload;else try {
        return JSON.parse(payload);
      } catch (err) {}
    } // Return conf object


    function getConf(id) {
      return widgetLocalData.instancesData[id].lpConfig;
    } // Return conf object


    function getWtbConf(id) {
      return widgetLocalData.instancesData[id].wtbConf;
    } // extract some parameters from host query string


    function setUrlConf() {
      var kvs = location.search.substr(1).split('&');
      kvs.forEach(function (kv) {
        var key, value;

        var _kv$split = kv.split('=');

        var _kv$split2 = _slicedToArray(_kv$split, 2);

        key = _kv$split2[0];
        value = _kv$split2[1];

        switch (key) {
          case 'wtbean':
            widgetLocalData.urlConf.defaultPrd = value;
            break;

          case 'wtbtrk':
            widgetLocalData.urlConf.trk = value;
            break;

          case 'wtbfilters':
            widgetLocalData.urlConf.filters = value;
            break;
        }
      });
    } // Send all the message waiting the widget to be ready


    function sendWaitingFrameMessage(id) {
      if (!waitingPostMessage[id]) return;
      waitingPostMessage[id].forEach(function (messageObject) {
        sendMessage(messageObject.target, messageObject.data);
      });
      delete waitingPostMessage[id];
    } // postMessage handler
    // @param {Object} event : message received


    function receiveMessage(event) {
      var origin = event.origin.replace(/^https?:/g, '');
      var dest = null;
      if (lpHost.indexOf(origin) !== 0 && origin.indexOf('.swaven.com') === -1) return;
      if (!event || !event.data) return;
      var data = deserialize(event.data),
          resp = null;

      switch (data.action) {
        case 'lp:iframeready':
          if (data.id) {
            widgetLocalData.instancesData[data.id].iframeReady = true;

            var _iframe = document.getElementById(IFRAME_ID_PREFIX + data.id);

            _iframe.style.display = 'block';
            sendWaitingFrameMessage(data.id);
          }

          break;

        case 'lp:settid':
          if (data.tid) setTid(data.tid, data.region);
          break;

        case 'lp:clientCallback':
          if (data.id && widgetLocalData.instancesData[data.id].clientCallback) widgetLocalData.instancesData[data.id].clientCallback(data.trkData);
          break;

        case 'lp:serverTracking':
          if (data) addScript(data.script);
          break;

        case 'lp:pixelTracking':
          if (data.url) {
            var pxTag = document.createElement("img");
            pxTag.style.display = "none";
            pxTag.src = data.url;
            document.body.appendChild(pxTag);
          }

          break;

        case 'lp:mobileMode':
          document.querySelector('body').classList.add('swn-lp-mobile');
          document.querySelector('#' + IFRAME_ID_PREFIX + data.id).style.height = '';
          break;

        case 'lp:desktopMode':
          document.querySelector('body').classList.remove('swn-lp-mobile'); // Reset inline height

          document.getElementById(data.id).style.height = '';
          var iframe = document.getElementById(IFRAME_ID_PREFIX + data.id);
          if (iframe.style.height === '' && data.width < 950) iframe.style.height = '700px';else if (iframe.style.height !== '' && data.width >= 950) iframe.style.height = '';
          break;

        case 'lp:getClientBounds':
          // Send height of the viewport to the widget
          resp = {
            viewportHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
            action: 'lp:clientBounds'
          };
          document.getElementById(data.id).querySelector('iframe').scrollIntoView();
          break;

        case 'lp:getViewportSize':
          resp = {
            viewportHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
            viewportWidth: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
            action: 'lp:viewportSize'
          };

        case 'lp:resize':
          // Update new widget size
          var lpMobile = document.querySelector('body.swn-lp-mobile #' + data.id);
          if (lpMobile) lpMobile.style.height = data.height + 'px';
          break;

        case 'lp:geoloc':
          setPersistedGeoloc(data);
          break;

        case 'lp:browserGeoloc':
          if (data.id) getUserLoc(data.id, data.auto);
          break;

        case 'lp:deleteGeoloc':
          delPersistedGeoloc(data.host);
          break;

        case 'lp:getDisplayedHeight':
          resp = {
            action: 'lp:scrollVP',
            displayedHeight: getDisplayedHeight(document.getElementById(data.id)),
            auto: 1
          };
          break;

        case 'lp:close':
          if (data.id) closeWidget(data.id);
          break;
      }

      if (resp != null) {
        // answers the message
        if (data.timestamp) resp.timestamp = data.timestamp;
        sendMessage(event.source, resp, dest);
      }
    } // Saves a manual or html5 geolocation on local storage
    // @param {object} data: contains properties loc: location info


    function setPersistedGeoloc(data) {
      var address = JSON.stringify(data.loc);
      if (typeof window.btoa === 'function') address = window.btoa(address);
      localStorage.setItem('swnAddress', address);
    } // get a persisted manual or html5 geolocation


    function getPersistedGeoloc() {
      var address = localStorage.getItem('swnAddress');

      if (address) {
        if (typeof window.atob === 'function') address = window.atob(address);
        return JSON.parse(address);
      }

      return null;
    } // Deletes persisted geoloc


    function delPersistedGeoloc() {
      localStorage.removeItem('swnAddress');
    } // Post message handler
    // @param {Object} target : target to send data
    // @param {Object} data : data to send
    // @param {String} dest : destination


    function sendMessage(target, data, dest) {
      if (dest == null) dest = '*';
      var payload = postObj ? data : JSON.stringify(data);
      target.postMessage(payload, dest);
    } // Send message to iframe to load LP
    // @param {Object} container : iframe to send message


    function loadLp(container) {
      var id = container.name,
          data = {
        action: 'lp:load',
        cfg: getConf(id),
        wtbConf: getWtbConf(id),
        session: widgetLocalData.instancesData[id].session
      };
      if (widgetLocalData.instancesData[id].iframeReady) sendMessage(container.contentWindow, data);else {
        waitingPostMessage[id] = waitingPostMessage[id] || [];
        waitingPostMessage[id].push({
          target: container.contentWindow,
          data: data
        });
      }
    } // Initiate the generation of the iframes
    // @param {Object} configuration : lp's configurations


    window.swnInitLp = function (configuration) {
      if (configuration.instance != null) {
        configuration.instances = [configuration.instance];
        delete configuration.instance;
      }

      if (configuration.closeCallback) setLpCloseCallback(configuration.closeCallback);
      if (configuration.pageId) pageId = configuration.pageId;
      configuration.instances.forEach(function (instance) {
        var tagConfig = getNewOptionObject();

        if (!instance.id) {
          instance.id = 'lp-' + uuid();
          instance.params = instance.params || {};
          instance.params.popin = true;
        } else {
          var container = document.getElementById(instance.id);
          if (!container) throw new Error('No container found for the id ' + instance.id + '.');
          tagConfig = getLpOptions(container);
        }

        if (configuration.test) {
          instance.params = instance.params || {};
          instance.params.test = true;
        } // If a params object is given, then override the parameters we got from data-attibutes


        if (instance.params && Object.keys(instance.params).length > 0) replaceObject(tagConfig, serializeConfPattern(instance.params));
        if (!instance.wtbid && !tagConfig.wtbid) throw new Error('Cannot find wtbid.');
        if (configuration.trkCallback && !instance.trkCallback) instance.trkCallback = configuration.trkCallback;
        instance.session = configuration.session;
        getLPConf(instance, tagConfig);
      });
      verifyConfigs();
    };

    window.swnShowLp = function (id, newConf, auto) {
      auto = auto || false;

      if (newConf != null && _typeof(newConf) === 'object') {
        var partialNewConf;
        if (newConf.nodeType) // If it's a DOM element then we extract the new conf with the data-attribute
          partialNewConf = getLpOptions(newConf);else partialNewConf = serializeConfPattern(newConf);
        delete partialNewConf.wtbid; // disallow overriding of wtbid

        newConf = clone(widgetLocalData.originalConfs[id].options);
        replaceObject(newConf, partialNewConf);
        processOptions(newConf, id);

        if (!objectEquals(newConf, widgetLocalData.instancesData[id].lpConfig.options)) {
          if (!needToFullyReload(partialNewConf, widgetLocalData.instancesData[id].lpConfig.options)) updateIframe(id, newConf);else reloadIframe(id, newConf);
          widgetLocalData.instancesData[id].lpConfig.options = newConf;
        }
      }

      var data = {
        action: 'lp:open',
        auto: auto,
        loc: getPersistedGeoloc(),
        crispCompare: crispCompare
      },
          iframe = document.getElementById(IFRAME_ID_PREFIX + id);
      iframe.classList.remove('swn-lp-ctn-hide');

      if (widgetLocalData.instancesData[id].lpConfig.options.popin) {
        iframe.parentNode.classList.remove('swn-lp-popin-closed'); // try to get document.body but we might have a chance it's not initialised yet so also use a fallback

        var body = document.body || document.getElementsByTagName('body');
        body.classList.add('swn-lp-popin-open');
      }

      if (widgetLocalData.instancesData[id].buttons != null) {
        widgetLocalData.instancesData[id].buttons.forEach(function (btn) {
          btn.classList.add('swn-wtb-btn-open');
        });
      }

      if (widgetLocalData.instancesData[id].iframeReady) sendMessage(iframe.contentWindow, data);else {
        if (!waitingPostMessage[id]) waitingPostMessage[id] = [];
        waitingPostMessage[id].push({
          target: iframe.contentWindow,
          data: data
        });
      }
      if (!widgetLocalData.instancesData[id].lpConfig.options.autoOpen) // Focus on the widget to avoid having to tab the whole page to access the widget
        iframe.contentWindow.focus();
    };

    window.swnHideLp = function (id) {
      closeWidget(id);
      var data = {
        action: 'lp:close'
      },
          iframe = document.getElementById(IFRAME_ID_PREFIX + id);
      if (widgetLocalData.instancesData[id].iframeReady) sendMessage(iframe.contentWindow, data);else {
        if (!waitingPostMessage[id]) waitingPostMessage[id] = [];
        waitingPostMessage[id].push({
          target: iframe.contentWindow,
          data: data
        });
      }
    };

    window.swnCheckAvailability = function (id, newConf, callback, itl) {
      itl = itl != null ? itl : 10;
      if (typeof callback !== 'function') return console.log('callback is missing');
      if (!newConf) return console.log('new data not provided');
      if (!id) id = Object.keys(widgetLocalData.instancesData)[0]; // If the conf is not available yet, wait 100ms

      if (!widgetLocalData.instancesData[id]) {
        if (itl === 0) {
          // If iteration to live (itl) reach 0 we consider we'll never have the conf so stop to wait
          return console.warn('Check availability failed');
        }

        return setTimeout(function () {
          swnCheckAvailability(id, newConf, callback, --itl);
        }, 100);
      }

      var partialNewConf = serializeConfPattern(newConf),
          newConf = clone(widgetLocalData.originalConfs[id].options);
      replaceObject(newConf, partialNewConf);
      var scope = getAvailabilityScope(newConf),
          wtbConf = widgetLocalData.instancesData[id].wtbConf;
      checkAvailabilities(scope, wtbConf, callback);
    }; // gets data attribute's value from item
    // @param {Object} container : container
    // @param {String} dataAttribute : data attribute


    function getLpDataAttribute(container, dataAttribute) {
      if (container.dataset) return container.dataset[dataAttribute];else return container.getAttribute('data-' + toSwnDashed(dataAttribute));
    } // Change camel case name to dashed
    // @param {String} name : the name to convert


    function toSwnDashed(name) {
      if (!name) return '';
      return name.replace(/([A-Z])/g, function (u) {
        return '-' + u.toLowerCase();
      });
    }

    function lowercaseFirstLetter(string) {
      return string.charAt(0).toLowerCase() + string.slice(1);
    }

    function getLocaleOptions(container, localeObj) {
      var keys = Object.keys(container.dataset),
          localeRegExp = /^locale/,
          langRegExp = /^locale([A-Z][a-z]_?[a-z]{0,2})(.*)/,
          localeKeys = keys.filter(function (x) {
        return x.match(localeRegExp);
      }),
          newObj = {};
      localeKeys.forEach(function (localeKey) {
        var res = langRegExp.exec(localeKey);

        if (res && res[1] && res[2]) {
          var lang = res[1].toLowerCase().replace('_', '-'),
              option = toSwnDashed(lowercaseFirstLetter(res[2]));
          newObj[lang] = newObj[lang] || {};
          newObj[lang][option] = container.dataset[localeKey];
        }
      });

      for (var key in newObj) {
        var value = newObj[key];
        newObj[key] = serializeConfPattern(value);
        if (localeObj[key]) replaceObject(localeObj[key], newObj[key]);else localeObj[key] = newObj[key];
      }
    }

    function getLpStyleOptions(container, style) {
      // Global options
      var globalBtnColor = getLpDataAttribute(container, 'globalBtnColor');
      if (globalBtnColor) style.global.btnColor = globalBtnColor;
      var globalBtnColorHover = getLpDataAttribute(container, 'globalBtnColorHover');
      if (globalBtnColorHover) style.global.btnColorHover = globalBtnColorHover;
      var globalBtnBg = getLpDataAttribute(container, 'globalBtnBg');
      if (globalBtnBg) style.global.btnBg = globalBtnBg;
      var globalBtnBgHover = getLpDataAttribute(container, 'globalBtnBgHover');
      if (globalBtnBgHover) style.global.btnBgHover = globalBtnBgHover;
      var globalBtnBorder = getLpDataAttribute(container, 'globalBtnBorder');
      if (globalBtnBorder) style.global.btnBorder = globalBtnBorder;
      var globalBtnBorderHover = getLpDataAttribute(container, 'globalBtnBorderHover');
      if (globalBtnBorderHover) style.global.btnBorderHover = globalBtnBorderHover;
      var globalBtnBorderRadius = getLpDataAttribute(container, 'globalBtnBorderRadius');
      if (globalBtnBorderRadius) style.global.btnBorderRadius = globalBtnBorderRadius;
      var globalFontFamily = getLpDataAttribute(container, 'globalFontFamily');
      if (globalFontFamily) style.global.fontFamily = globalFontFamily;
      var globalFontSrc = getLpDataAttribute(container, 'globalFontSrc');
      if (globalFontSrc) style.global.fontSrc = globalFontSrc;
      var globalColor = getLpDataAttribute(container, 'globalColor');
      if (globalColor) style.global.color = globalColor;
      var globalBg = getLpDataAttribute(container, 'globalBg');
      if (globalBg) style.global.bg = globalBg;
      var globalBorderRadius = getLpDataAttribute(container, 'globalBorderRadius');
      if (globalBorderRadius) style.global.borderRadius = globalBorderRadius;
      var globalBlockBorderColor = getLpDataAttribute(container, 'globalBlockBorderColor');
      if (globalBlockBorderColor) style.global.blockBorderColor = globalBlockBorderColor;
      var globalBlockBg = getLpDataAttribute(container, 'globalBlockBg');
      if (globalBlockBg) style.global.blockBg = globalBlockBg;
      var globalBlockBorderRadius = getLpDataAttribute(container, 'globalBlockBorderRadius');
      if (globalBlockBorderRadius) style.global.blockBorderRadius = globalBlockBorderRadius;
      var globalFontSize = getLpDataAttribute(container, 'globalFontSize');
      if (globalFontSize) style.global.fontSize = globalFontSize;
      var globalTextTransform = getLpDataAttribute(container, 'globalTextTransform');
      if (globalTextTransform) style.global.textTransform = globalTextTransform; // Loader

      var loaderColor = getLpDataAttribute(container, 'loaderColor');
      if (loaderColor) style.loader.color = loaderColor;
      var loaderBg = getLpDataAttribute(container, 'loaderBg');
      if (loaderBg) style.loader.bg = loaderBg; // Location bar

      var locbarBtnColor = getLpDataAttribute(container, 'locbarBtnColor');
      if (locbarBtnColor) style.locbar.btnColor = locbarBtnColor;
      var locbarInputColor = getLpDataAttribute(container, 'locbarInputColor');
      if (locbarInputColor) style.locbar.inputColor = locbarInputColor;
      var locbarInputBg = getLpDataAttribute(container, 'locbarInputBg');
      if (locbarInputBg) style.locbar.inputBg = locbarInputBg;
      var locbarInputColorHover = getLpDataAttribute(container, 'locbarInputColorHover');
      if (locbarInputColorHover) style.locbar.inputColorHover = locbarInputColorHover;
      var locbarInputBgHover = getLpDataAttribute(container, 'locbarInputBgHover');
      if (locbarInputBgHover) style.locbar.inputBgHover = locbarInputBgHover;
      var locbarInputBorderRadius = getLpDataAttribute(container, 'locbarInputBorderRadius');
      if (locbarInputBorderRadius) style.locbar.inputBorderRadius = locbarInputBorderRadius; // Product list

      var productlistItemColor = getLpDataAttribute(container, 'productlistItemColor');
      if (productlistItemColor) style.productlist.itemColor = productlistItemColor;
      var productlistItemBg = getLpDataAttribute(container, 'productlistItemBg');
      if (productlistItemBg) style.productlist.itemBg = productlistItemBg;
      var productlistItemBorderRadius = getLpDataAttribute(container, 'productlistItemBorderRadius');
      if (productlistItemBorderRadius) style.productlist.itemBorderRadius = productlistItemBorderRadius;
      var productlistItemBorder = getLpDataAttribute(container, 'productlistItemBorder');
      if (productlistItemBorder) style.productlist.itemBorder = productlistItemBorder;
      var productlistItemColorHover = getLpDataAttribute(container, 'productlistItemColorHover');
      if (productlistItemColorHover) style.productlist.itemColorHover = productlistItemColorHover;
      var productlistItemBgHover = getLpDataAttribute(container, 'productlistItemBgHover');
      if (productlistItemBgHover) style.productlist.itemBgHover = productlistItemBgHover;
      var productlistItemBorderHover = getLpDataAttribute(container, 'productlistItemBorderHover');
      if (productlistItemBorderHover) style.productlist.itemBorderHover = productlistItemBorderHover;
      var productlistItemColorSelected = getLpDataAttribute(container, 'productlistItemColorSelected');
      if (productlistItemColorSelected) style.productlist.itemColorSelected = productlistItemColorSelected;
      var productlistItemBgSelected = getLpDataAttribute(container, 'productlistItemBgSelected');
      if (productlistItemBgSelected) style.productlist.itemBgSelected = productlistItemBgSelected;
      var productlistItemBorderSelected = getLpDataAttribute(container, 'productlistItemBorderSelected');
      if (productlistItemBorderSelected) style.productlist.itemBorderSelected = productlistItemBorderSelected;
      var productlistItemDisplayShadow = getLpDataAttribute(container, 'productlistItemDisplayShadow');
      if (productlistItemDisplayShadow === 'false') style.productlist.itemDisplayShadow = productlistItemDisplayShadow;
      var productlistItemFontSize = getLpDataAttribute(container, 'productlistItemFontSize');
      if (productlistItemFontSize) style.productlist.itemFontSize = productlistItemFontSize;
      var productlistNavBgColor = getLpDataAttribute(container, 'productlistNavBgColor') || getLpDataAttribute(container, 'productlistNavColor');
      if (productlistNavBgColor) style.productlist.navBgColor = productlistNavBgColor;
      var productlistNavBgColorHover = getLpDataAttribute(container, 'productlistNavBgColorHover') || getLpDataAttribute(container, 'productlistNavColorHover');
      if (productlistNavBgColorHover) style.productlist.navBgColorHover = productlistNavBgColorHover;
      var productlistItemLabelRows = getLpDataAttribute(container, 'productlistItemLabelRows');
      if (productlistItemLabelRows) style.productlist.itemLabelRows = productlistItemLabelRows;
      var headerColor = getLpDataAttribute(container, 'headerColor');
      if (headerColor) style.header.color = headerColor;
      var headerBg = getLpDataAttribute(container, 'headerBg');
      if (headerBg) style.header.bg = headerBg;
      var productColor = getLpDataAttribute(container, 'productColor');
      if (productColor) style.product.color = productColor;
      var productBg = getLpDataAttribute(container, 'productBg');
      if (productBg) style.product.bg = productBg;
      var productBorderColor = getLpDataAttribute(container, 'productBorderColor');
      if (productBorderColor) style.product.borderColor = productBorderColor;
      var productBorderRadius = getLpDataAttribute(container, 'productBorderRadius');
      if (productBorderRadius) style.product.borderRadius = productBorderRadius;
      var productTextAlign = getLpDataAttribute(container, 'productTextAlign');
      if (productTextAlign) style.product.textAlign = productTextAlign;
      var productFontSize = getLpDataAttribute(container, 'productFontSize');
      if (productFontSize) style.product.fontSize = productFontSize; // Store list

      var storelistBorderRadius = getLpDataAttribute(container, 'storelistBorderRadius');
      if (storelistBorderRadius) style.storelist.borderRadius = storelistBorderRadius;
      var storelistBorderColor = getLpDataAttribute(container, 'storelistBorderColor');
      if (storelistBorderColor) style.storelist.borderColor = storelistBorderColor;
      var storelistBg = getLpDataAttribute(container, 'storelistBg');
      if (storelistBg) style.storelist.bg = storelistBg;
      var storelistBgHover = getLpDataAttribute(container, 'storelistBgHover');
      if (storelistBgHover) style.storelist.bgHover = storelistBgHover; // Store

      var storeColor = getLpDataAttribute(container, 'storeColor');
      if (storeColor) style.store.color = storeColor;
      var storeBtnColor = getLpDataAttribute(container, 'storeBtnColor');
      if (storeBtnColor) style.store.btnColor = storeBtnColor;
      var storeBtnBg = getLpDataAttribute(container, 'storeBtnBg');
      if (storeBtnBg) style.store.btnBg = storeBtnBg;
      var storeBtnBorderColor = getLpDataAttribute(container, 'storeBtnBorderColor');
      if (storeBtnBorderColor) style.store.btnBorderColor = storeBtnBorderColor;
      var storeBtnColorHover = getLpDataAttribute(container, 'storeBtnColorHover');
      if (storeBtnColorHover) style.store.btnColorHover = storeBtnColorHover;
      var storeBtnBgHover = getLpDataAttribute(container, 'storeBtnBgHover');
      if (storeBtnBgHover) style.store.btnBgHover = storeBtnBgHover;
      var storeBtnBorderColorHover = getLpDataAttribute(container, 'storeBtnBorderColorHover');
      if (storeBtnBorderColorHover) style.store.btnBorderColorHover = storeBtnBorderColorHover;
      var storeLocBtnColor = getLpDataAttribute(container, 'storeLocBtnColor');
      if (storeLocBtnColor) style.store.locBtnColor = storeLocBtnColor;
      var storeLocBtnBg = getLpDataAttribute(container, 'storeLocBtnBg');
      if (storeLocBtnBg) style.store.locBtnBg = storeLocBtnBg;
      var storeLocBtnBorderColor = getLpDataAttribute(container, 'storeLocBtnBorderColor');
      if (storeLocBtnBorderColor) style.store.locBtnBorderColor = storeLocBtnBorderColor;
      var storeLocBtnColorHover = getLpDataAttribute(container, 'storeLocBtnColorHover');
      if (storeLocBtnColorHover) style.store.locBtnColorHover = storeLocBtnColorHover;
      var storeLocBtnBgHover = getLpDataAttribute(container, 'storeLocBtnBgHover');
      if (storeLocBtnBgHover) style.store.locBtnBgHover = storeLocBtnBgHover;
      var storeLocBtnBorderColorHover = getLpDataAttribute(container, 'storeLocBtnBorderColorHover');
      if (storeLocBtnBorderColorHover) style.store.locBtnBorderColorHover = storeLocBtnBorderColorHover;
      var storeDisabledBtnColor = getLpDataAttribute(container, 'storeDisabledBtnColor');
      if (storeDisabledBtnColor) style.store.disabledBtnColor = storeDisabledBtnColor;
      var storeDisabledBtnBg = getLpDataAttribute(container, 'storeDisabledBtnBg');
      if (storeDisabledBtnBg) style.store.disabledBtnBg = storeDisabledBtnBg;
      var storeFontSize = getLpDataAttribute(container, 'storeFontSize');
      if (storeFontSize) style.store.fontSize = storeFontSize;
      var storeBtnFontSize = getLpDataAttribute(container, 'storeBtnFontSize');
      if (storeBtnFontSize) style.store.btnFontSize = storeBtnFontSize;
      var storeTextTransform = getLpDataAttribute(container, 'storeTextTransform');
      if (storeTextTransform) style.store.textTransform = storeTextTransform;
      var storeBtnTextTransform = getLpDataAttribute(container, 'storeBtnTextTransform');
      if (storeBtnTextTransform) style.store.btnTextTransform = storeBtnTextTransform;
      var storeBtnBorderRadius = getLpDataAttribute(container, 'storeBtnBorderRadius');
      if (storeBtnBorderRadius) style.store.btnBorderRadius = storeBtnBorderRadius; // infowindow

      var infowindowColor = getLpDataAttribute(container, 'infowindowColor');
      if (infowindowColor) style.infowindow.color = infowindowColor;
      var infowindowBtnColor = getLpDataAttribute(container, 'infowindowBtnColor');
      if (infowindowBtnColor) style.infowindow.btnColor = infowindowBtnColor;
      var infowindowBtnBg = getLpDataAttribute(container, 'infowindowBtnBg');
      if (infowindowBtnBg) style.infowindow.btnBg = infowindowBtnBg;
      var infowindowBtnBorder = getLpDataAttribute(container, 'infowindowBtnBorder');
      if (infowindowBtnBorder) style.infowindow.btnBorder = infowindowBtnBorder;
      var infowindowBtnColorHover = getLpDataAttribute(container, 'infowindowBtnColorHover');
      if (infowindowBtnColorHover) style.infowindow.btnColorHover = infowindowBtnColorHover;
      var infowindowBtnBgHover = getLpDataAttribute(container, 'infowindowBtnBgHover');
      if (infowindowBtnBgHover) style.infowindow.btnBgHover = infowindowBtnBgHover;
      var infowindowBtnBorderHover = getLpDataAttribute(container, 'infowindowBtnBorderHover');
      if (infowindowBtnBorderHover) style.infowindow.btnBorderHover = infowindowBtnBorderHover;
      var infowindowFontSize = getLpDataAttribute(container, 'infowindowFontSize');
      if (infowindowFontSize) style.infowindow.fontSize = infowindowFontSize;
      var infowindowBtnFontSize = getLpDataAttribute(container, 'infowindowBtnFontSize');
      if (infowindowBtnFontSize) style.infowindow.btnFontSize = infowindowBtnFontSize;
      var infowindowTextTransform = getLpDataAttribute(container, 'infowindowTextTransform');
      if (infowindowTextTransform) style.infowindow.textTransform = infowindowTextTransform;
      var infowindowBtnTextTransform = getLpDataAttribute(container, 'infowindowBtnTextTransform');
      if (infowindowBtnTextTransform) style.infowindow.btnTextTransform = infowindowBtnTextTransform;
      var buttonPositionX = getLpDataAttribute(container, 'buttonPositionX');
      if (buttonPositionX) style.button.positionX = buttonPositionX;
      var buttonPositionY = getLpDataAttribute(container, 'buttonPositionY');
      if (buttonPositionY) style.button.positionY = buttonPositionY;
      var buttonText = getLpDataAttribute(container, 'buttonText');
      if (buttonText) style.button.text = buttonText;
      var buttonFontSize = getLpDataAttribute(container, 'buttonFontSize');
      if (buttonFontSize) style.button.fontSize = buttonFontSize;
      var buttonColor = getLpDataAttribute(container, 'buttonColor');
      if (buttonColor) style.button.color = buttonColor;
      var buttonColorHover = getLpDataAttribute(container, 'buttonColorHover');
      if (buttonColorHover) style.button.colorHover = buttonColorHover;
      var buttonBg = getLpDataAttribute(container, 'buttonBg');
      if (buttonBg) style.button.bg = buttonBg;
      var buttonBgHover = getLpDataAttribute(container, 'buttonBgHover');
      if (buttonBgHover) style.button.bgHover = buttonBgHover;
      var buttonTransition = getLpDataAttribute(container, 'buttonTransition');
      if (buttonTransition) style.button.transition = buttonTransition;
      var buttonPadding = getLpDataAttribute(container, 'buttonPadding');
      if (buttonPadding) style.button.padding = buttonPadding;
      var buttonBorderRadius = getLpDataAttribute(container, 'buttonBorderRadius');
      if (buttonBorderRadius) style.button.borderRadius = buttonBorderRadius;
      var buttonBorder = getLpDataAttribute(container, 'buttonBorder');
      if (buttonBorder) style.button.border = buttonBorder;
      var buttonBorderHover = getLpDataAttribute(container, 'buttonBorderHover');
      if (buttonBorderHover) style.button.borderHover = buttonBorderHover;
      var buttonTextTransform = getLpDataAttribute(container, 'buttonTextTransform');
      if (buttonTextTransform) style.button.textTransform = buttonTextTransform;
      var buttonImgUrl = getLpDataAttribute(container, 'buttonImgUrl');
      if (buttonImgUrl) style.button.imgUrl = buttonImgUrl;
      var buttonIconSide = getLpDataAttribute(container, 'buttonIconSide');
      if (buttonIconSide) style.button.iconSide = buttonIconSide;
      var buttonIconRotation = getLpDataAttribute(container, 'buttonIconRotation');
      if (buttonIconRotation) style.button.iconRotation = buttonIconRotation;
      var buttonImgUrlMobile = getLpDataAttribute(container, 'buttonImgUrlMobile');
      if (buttonImgUrlMobile) style.button.imgUrlMobile = buttonImgUrlMobile;
      var buttonMobileThreshold = getLpDataAttribute(container, 'buttonMobileThreshold');
      if (buttonMobileThreshold) style.button.mobileThreshold = buttonMobileThreshold;
      var buttonZIndex = getLpDataAttribute(container, 'buttonZIndex');
      if (buttonZIndex) style.button.zIndex = buttonZIndex;
      var buttonZIndexMobile = getLpDataAttribute(container, 'buttonZIndexMobile');
      if (buttonZIndexMobile) style.button.zIndexMobile = buttonZIndexMobile;
      var buttonImgWidth = getLpDataAttribute(container, 'buttonImgWidth');
      if (buttonImgWidth) style.button.imgWidth = buttonImgWidth;
      var buttonImgHeight = getLpDataAttribute(container, 'buttonImgHeight');
      if (buttonImgHeight) style.button.imgHeight = buttonImgHeight;
      var buttonImgWidthMobile = getLpDataAttribute(container, 'buttonImgWidthMobile');
      if (buttonImgWidthMobile) style.button.imgWidthMobile = buttonImgWidthMobile;
      var buttonImgHeightMobile = getLpDataAttribute(container, 'buttonImgHeightMobile');
      if (buttonImgHeightMobile) style.button.imgHeightMobile = buttonImgHeightMobile;
      return style;
    } // Gets options from data-attributes
    // @param {Object} container : container with data-attributes


    function getLpOptions(container) {
      var options = getNewOptionObject(),
          eans = getLpDataAttribute(container, 'eans');
      if (eans != null) options.eans = eans;
      var range = getLpDataAttribute(container, 'range');
      if (range != null) options.range = range;
      var wtbid = getLpDataAttribute(container, 'wtbid');
      if (wtbid != null) options.wtbid = wtbid;
      var appid = getLpDataAttribute(container, 'appid');
      if (appid != null) options.appid = appid;
      var lang = getLpDataAttribute(container, 'lang');
      if (lang != null) options.lang = lang;
      var trk = getLpDataAttribute(container, 'trk');
      if (trk != null) options.trk = trk;
      var defaultPrd = getLpDataAttribute(container, 'defaultPrd');
      if (defaultPrd != null) options.defaultPrd = defaultPrd;
      var headerLogo = getLpDataAttribute(container, 'headerLogo');
      if (headerLogo != null) options.headerLogo = headerLogo;
      var headerLabel = getLpDataAttribute(container, 'headerLabel');
      if (headerLabel != null) options.headerLabel = headerLabel;
      var productLabelPattern = getLpDataAttribute(container, 'productLabelPattern');
      if (productLabelPattern != null) options.productLabelPattern = productLabelPattern;
      var noStoreMsg = getLpDataAttribute(container, 'noStoreMsg');
      if (noStoreMsg != null) options.noStoreMsg = noStoreMsg;
      var srvErrMsg = getLpDataAttribute(container, 'srvErrMsg');
      if (srvErrMsg != null) options.srvErrMsg = srvErrMsg; // Remove prdListItemLabel1Pattern when Taft and JPG campaigns are done

      var prdListItemLabelPattern = getLpDataAttribute(container, 'prdListItemLabel1Pattern') || getLpDataAttribute(container, 'prdListItemLabelPattern');
      if (prdListItemLabelPattern != null) options.prdListItemLabelPattern = prdListItemLabelPattern;
      var buyBtnTxt = getLpDataAttribute(container, 'buyBtnTxt');
      if (buyBtnTxt != null) options.buyBtnTxt = buyBtnTxt;
      var locBtnTxt = getLpDataAttribute(container, 'locBtnTxt');
      if (locBtnTxt != null) options.locBtnTxt = locBtnTxt;
      var routeBtnTxt = getLpDataAttribute(container, 'routeBtnTxt');
      if (routeBtnTxt != null) options.routeBtnTxt = routeBtnTxt;
      var trackingPx = getLpDataAttribute(container, 'trackingPx');
      if (trackingPx != null) options.trackingPx = trackingPx;
      var actionCallback = getLpDataAttribute(container, 'actionCallback');
      if (actionCallback != null) options.actionCallback = actionCallback;
      var authd = getLpDataAttribute(container, 'authd');
      if (authd != null) options.authd = authd;
      var auth = getLpDataAttribute(container, 'auth');
      if (auth != null) options.auth = auth;
      var popin = getLpDataAttribute(container, 'popin');
      if (popin === 'true') options.popin = true;
      var mobileFullscreen = getLpDataAttribute(container, 'mobileFullscreen');
      if (mobileFullscreen != null) options.mobileFullscreen = mobileFullscreen != 'false';
      var hidePrdOnMobile = getLpDataAttribute(container, 'hidePrdOnMobile');
      if (hidePrdOnMobile != null) options.hidePrdOnMobile = hidePrdOnMobile;
      var hidePrdImgOnMobile = getLpDataAttribute(container, 'hidePrdImgOnMobile');
      if (hidePrdImgOnMobile != null) options.hidePrdImgOnMobile = hidePrdImgOnMobile;
      var geoAddr = getLpDataAttribute(container, 'geoAddr');
      if (geoAddr) options.geoAddr = geoAddr;
      var geoLat = getLpDataAttribute(container, 'geoLat');
      if (geoLat) options.geoLat = geoLat;
      var geoLng = getLpDataAttribute(container, 'geoLng');
      if (geoLng) options.geoLng = geoLng;
      var geoZipcode = getLpDataAttribute(container, 'geoZipcode');
      if (geoZipcode) options.geoZipcode = geoZipcode;
      var geoCity = getLpDataAttribute(container, 'geoCity');
      if (geoCity) options.geoCity = geoCity;
      var stylesheet = getLpDataAttribute(container, 'stylesheet');
      if (stylesheet) options.stylesheet = stylesheet;
      var autoOpen = getLpDataAttribute(container, 'autoOpen');
      if (autoOpen != null) options.autoOpen = autoOpen != 'false';
      var closeBtn = getLpDataAttribute(container, 'closeBtn');
      if (closeBtn === 'true') options.closeBtn = true;
      var buttonMode = getLpDataAttribute(container, 'buttonMode');
      if (buttonMode != null) options.buttonMode = buttonMode;
      var isStudio = getLpDataAttribute(container, 'isStudio');
      if (isStudio === 'true') options.isStudio = true;
      var displayProductPanel = getLpDataAttribute(container, 'displayProductPanel');
      if (displayProductPanel != null) options.displayProductPanel = displayProductPanel;
      var ajax = getLpDataAttribute(container, 'ajax');
      if (ajax === 'true') options.ajax = true;
      var cookieNotifTheme = getLpDataAttribute(container, 'cookieNotifTheme');
      if (cookieNotifTheme) options.cookieNotifTheme = cookieNotifTheme;
      var checkAvailabilityOnDefaultPrd = getLpDataAttribute(container, 'checkAvailabilityOnDefaultPrd') === 'true';
      if (checkAvailabilityOnDefaultPrd) options.checkAvailabilityOnDefaultPrd = checkAvailabilityOnDefaultPrd;
      var disableBrowserAutoGeolocation = getLpDataAttribute(container, 'disableBrowserAutoGeolocation');
      if (disableBrowserAutoGeolocation) options.disableBrowserAutoGeolocation = disableBrowserAutoGeolocation == 'true'; // cookie notification banner texts related options

      var cookieNotifTxt = getLpDataAttribute(container, 'cookieNotifTxt');
      if (cookieNotifTxt) options.cookieNotifTxt = cookieNotifTxt;
      var cookieNotifOkTxt = getLpDataAttribute(container, 'cookieNotifOkTxt');
      if (cookieNotifOkTxt) options.cookieNotifOkTxt = cookieNotifOkTxt;
      var cookieNotifMoreTxt = getLpDataAttribute(container, 'cookieNotifMoreTxt');
      if (cookieNotifMoreTxt) options.cookieNotifMoreTxt = cookieNotifMoreTxt;
      var cookieNotifLink = getLpDataAttribute(container, 'cookieNotifLink');
      if (cookieNotifLink) options.cookieNotifLink = cookieNotifLink;
      var iframeTitle = getLpDataAttribute(container, 'iframeTitle');
      if (iframeTitle) options.iframeTitle = iframeTitle;
      var noOffline = getLpDataAttribute(container, 'noOffline');
      if (noOffline === 'true') options.noOffline = true;
      var noStoreInfo = getLpDataAttribute(container, 'noStoreInfo');
      if (noStoreInfo === 'true') options.noStoreInfo = true;
      var showFilters = getLpDataAttribute(container, 'showFilters');
      if (showFilters == 'true') options.showFilters = true;
      var filters = getLpDataAttribute(container, 'filters');
      if (filters) options.filters = filters;
      var customLink = getLpDataAttribute(container, 'customLink');
      if (customLink) options.customLink = customLink;
      var customLinkUrl = getLpDataAttribute(container, 'customLinkUrl');
      if (customLinkUrl) options.customLinkUrl = customLinkUrl;
      var modeStoreLocator = getLpDataAttribute(container, 'modeStoreLocator');
      if (modeStoreLocator === 'true') options.modeStoreLocator = true;
      var showTermsOfUse = getLpDataAttribute(container, 'showTermsOfUse');
      if (showTermsOfUse === 'false') options.showTermsOfUse = false;
      var apiVersion = getLpDataAttribute(container, 'apiVersion');
      if (apiVersion) options.apiVersion = apiVersion;
      var fillStores = getLpDataAttribute(container, 'fillStores');
      if (fillStores) options.fillStores = fillStores;
      var scrollToWidget = getLpDataAttribute(container, 'scrollToWidget');
      if (scrollToWidget === 'true') options.scrollToWidget = true;
      var lockdownHeaderTxt = getLpDataAttribute(container, 'lockdownHeaderTxt');
      if (lockdownHeaderTxt) options.lockdownHeaderTxt = lockdownHeaderTxt;
      var lockdownStoreTxt = getLpDataAttribute(container, 'lockdownStoreTxt');
      if (lockdownStoreTxt) options.lockdownStoreTxt = lockdownStoreTxt;
      getLpStyleOptions(container, options.style);
      getLocaleOptions(container, options.locale);
      return options;
    }

    function getLPConf(config, tagConfig) {
      var xhr = new XMLHttpRequest(),
          wtbid = config.wtbid || tagConfig.wtbid,
          url = API_URL + wtbid;
      if (config.remoteClientConfId) url = url + '?remoteClientConfigId=' + config.remoteClientConfId;

      xhr.onreadystatechange = function (response) {
        if (xhr.readyState === XMLHttpRequest_DONE) if (xhr.status === 200) processLp(config, JSON.parse(xhr.response), tagConfig);else throw new Error('error getting LP Conf');
      };

      xhr.open('GET', url, true);
      xhr.withCredentials = true;
      xhr.send(null);
    }

    function processLp(clientConfig, wtbConf, tagConfig) {
      var options;

      if (!tagConfig.isStudio && wtbConf.widgetclientparams && wtbConf.enableremoteconf) {
        options = serializeConfPattern(wtbConf.widgetclientparams.params);
        options.wtbid = wtbConf.Id; // Override the remote configuration parameters with the parameters we
        // got from data-attributes and/or the javascript conf pattern.

        replaceObject(options, tagConfig);
      } else options = tagConfig;

      var conf = {
        options: options,
        pageId: pageId,
        referrer: document.referrer,
        referrer2: document.location.href
      };
      widgetLocalData.instancesData[clientConfig.id] = widgetLocalData.instancesData[clientConfig.id] || {};
      widgetLocalData.instancesData[clientConfig.id].lpConfig = conf;
      widgetLocalData.instancesData[clientConfig.id].wtbConf = wtbConf;
      widgetLocalData.instancesData[clientConfig.id].iframeReady = false;
      if (clientConfig.session) widgetLocalData.instancesData[clientConfig.id].session = clientConfig.session;
      widgetLocalData.originalConfs[clientConfig.id] = clone(widgetLocalData.instancesData[clientConfig.id].lpConfig);
      processOptions(options, clientConfig.id);
      if (typeof clientConfig.trkCallback === 'function') widgetLocalData.instancesData[clientConfig.id].clientCallback = clientConfig.trkCallback;
      processButtons(clientConfig, options, wtbConf);
      generateIframe(clientConfig.id, conf);
      if (wtbConf.cookienotif && !getCookie('swncookieok')) initCookieUsageNotification(options.lang, options.cookieNotifTheme);
      if (wtbConf.test) console.warn('The widget is declared in test mode.');
    }

    function getAvailabilityScopeFromBtn(btn, widgetId, options) {
      var partialNewConf = getLpOptions(btn),
          optionsNeeded = {
        checkAvailabilityOnDefaultPrd: partialNewConf.checkAvailabilityOnDefaultPrd || options.checkAvailabilityOnDefaultPrd,
        eans: partialNewConf.eans || options.eans,
        range: partialNewConf.range || options.range,
        defaultPrd: partialNewConf.defaultPrd || options.defaultPrd
      };
      return getAvailabilityScope(optionsNeeded);
    }

    function getAvailabilityScope(options) {
      var scope;
      if (options.checkAvailabilityOnDefaultPrd) scope = options.defaultPrd;
      return scope || options.eans || options.range;
    }

    function checkAvailabilities(scope, wtbConf, callback) {
      // Ignore location when checking availabilities because it would
      // involve too much refactor code from widget to making it work properly
      // (rules to reload position if it's a HTML5 one, use getDistanceWithHaversine, ect)
      var xhr = new XMLHttpRequest(),
          region = wtbConf.region ? wtbConf.region + '-' : '',
          apiUrl = API_AV_URL.replace('{{region}}-', region),
          av = wtbConf.avprdonly || false,
          url = apiUrl + scope + '/status?forceAuto=true&lang=fr&av=' + av + '&wtbid=' + wtbConf.Id,
          geoloc = getPersistedGeoloc();
      if (geoloc != null) url += '&lat=' + geoloc.Latitude + '&lng=' + geoloc.Longitude + '&zc=' + geoloc.ZipCode + '&addr=' + geoloc.Address + '&cc=' + geoloc.Country + '&src=' + geoloc.Source + '&city=' + geoloc.City;

      xhr.onreadystatechange = function (response) {
        if (xhr.readyState === XMLHttpRequest_DONE) callback(xhr.status == 200 && JSON.parse(xhr.response).available);
      };

      xhr.open('GET', url, true);
      xhr.withCredentials = true;
      xhr.send(null);
    }

    function processButtons(clientConfig, options, wtbConf) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          processButtons(clientConfig, options, wtbConf);
        });
        return;
      }

      if (!clientConfig.buttons) clientConfig.buttons = ['.swn-wtb-btn'];else if (!Array.isArray(clientConfig.buttons)) // Convert in array if it's a single item
        clientConfig.buttons = [clientConfig.buttons];

      if (options.buttonMode === 'embedded') {
        var btn = generateButton(options, clientConfig.id);
        clientConfig.buttons.push(btn);
      }

      var btnList = [],
          availabilityBuffer = [];
      clientConfig.buttons.forEach(function (button) {
        var btns;
        if (button.nodeType) // No need to search for the buttons if we have a HTML element
          btns = [button];else if (typeof button === 'string') {
          var nl = document.querySelectorAll(button);
          btns = []; // convert NodeList to array (IE11 doesnt have NodeList.prototype.forEach)
          // for (let i = -1, l = nl.length; ++i !== l; )

          for (var i = 0; i < nl.length; i++) {
            btns[i] = nl[i];
          }
        }
        btns.forEach(function (btn) {
          btnList.push(btn); // Only check availabilities if the widget is not auto open an the feature is enabled in the conf

          if (!wtbConf.avprdonly || options.autoOpen) bindOpenButton(btn, clientConfig.id);else {
            var scope = getAvailabilityScopeFromBtn(btn, clientConfig.id, options);
            availabilityBuffer[scope] = availabilityBuffer[scope] || [];
            availabilityBuffer[scope].push(btn);
          }
        });
      });
      flushAvailabilityBuffer(availabilityBuffer, wtbConf, clientConfig.id);
      widgetLocalData.instancesData[clientConfig.id].buttons = btnList;

      if (options.ajax) {
        // if ajax mode is enabled, we need to periodically check if new buttons are present
        var querySelectors = clientConfig.buttons.filter(function (x) {
          return typeof x === 'string';
        });
        startBtnWatcher(querySelectors, clientConfig.id);
      }
    }

    function flushAvailabilityBuffer(availabilityBuffer, wtbConf, confId) {
      Object.keys(availabilityBuffer).forEach(function (scope) {
        var btns = availabilityBuffer[scope],
            callback = function callback(isAvailable) {
          btns.forEach(function (btn) {
            if (isAvailable) bindOpenButton(btn, confId);else btn.classList.add('swn-wtb-btn-disabled');
          });
        };

        checkAvailabilities(scope, wtbConf, callback);
      });
    }

    function processOptions(options, widgetId) {
      var locale = options.lang ? options.lang.toLowerCase() : 'en-gb',
          lang = locale.split('-')[0]; // First override the global lang (en,fr,de...)

      if (options.locale[lang]) replaceObject(options, options.locale[lang]); // Then override the locale lang (en-GB, fr-BE, de-CH...)

      if (locale !== lang && options.locale[locale]) replaceObject(options, options.locale[locale]);
      if (options.popin) options.mobileFullscreen = true;
      options.buttonMode = options.buttonMode || 'custom';
      if (options.mobileFullscreen == null) options.mobileFullscreen = true;
      if (options.autoOpen == null) options.autoOpen = true;
      if (widgetLocalData.urlConf.trk != null && !options.trk) options.trk = widgetLocalData.urlConf.trk;
      if (widgetLocalData.urlConf.defaultPrd != null && !options.defaultPrd) options.defaultPrd = widgetLocalData.urlConf.defaultPrd;
      if (widgetLocalData.urlConf.filters && !options.filters) options.filters = widgetLocalData.urlConf.filters;

      if (options.mobileFullscreen) {
        var lpMobileStyle = "\n          .swn-lp-mobile .swn-lp-ifr{\n            position: fixed;\n            left: 0;\n            top: 0;\n            width: 1px;\n            min-width: 100vw;\n            height: 100vh;\n            z-index: 100000;\n          }\n          .swn-lp-mobile.swn-lp-popin-open {\n            width: 100vw !important;\n            height: 100vh !important;\n            overflow: hidden;\n          }\n        }";
        addStyleNode(lpMobileStyle, 'swn-lp-mobile-fullscreen-style');
      } else // On no-fullscreen mobile, listen scrolls to track displayed stores
        document.addEventListener('scroll', pageScrolled); // Set text and remove it from options cause we don't need them anymore


      if (options.cookieNotifTxt) {
        cookieCustomTxts.COOKIESTXT = options.cookieNotifTxt;
        delete options.cookieNotifTxt;
      }

      if (options.cookieNotifOkTxt) {
        cookieCustomTxts.COOKIESOK = options.cookieNotifOkTxt;
        delete options.cookieNotifOkTxt;
      }

      if (options.cookieNotifMoreTxt) {
        cookieCustomTxts.COOKIESMORE = options.cookieNotifMoreTxt;
        delete options.cookieNotifMoreTxt;
      }

      if (options.cookieNotifLink) {
        cookieCustomTxts.COOKIESLINK = options.cookieNotifLink;
        delete options.cookieNotifLink;
      }

      var borderRadiusValue = options.style.global.borderRadius || '10px',
          lpborderRadiusStyle = "\n      @media screen and (min-width: 631px) {\n        #".concat(IFRAME_ID_PREFIX).concat(widgetId, "{\n          border-radius: ").concat(borderRadiusValue, ";\n        }\n      }\n    ");
      addStyleNode(lpborderRadiusStyle, "".concat(IFRAME_ID_PREFIX).concat(widgetId, "-border-radius-style"));
    }

    var scrollTimeout = null;

    function pageScrolled(e) {
      // Only do 200 ms after the last scroll
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        Object.keys(widgetLocalData.instancesData).forEach(function (id) {
          var container = document.getElementById(id),
              data = {
            action: 'lp:scrollVP',
            displayedHeight: getDisplayedHeight(container),
            auto: 0
          },
              iframe = container.querySelector('.swn-lp-ifr');
          if (widgetLocalData.instancesData[id].iframeReady) sendMessage(iframe.contentWindow, data);else waitingPostMessage[id].push({
            target: iframe.contentWindow,
            data: data
          });
        });
      }, 200);
    }

    function verifyConfigs() {
      var ids = Object.keys(widgetLocalData.instancesData);

      if (ids.length > 1) {
        ids.forEach(function (id) {
          var conf = widgetLocalData.instancesData[id];
          if (conf.lpConfig.options.mobileFullscreen === true) console.error('Setting mobile-fullscreen mode on when more than one widgets are on the page will cause issues');
        });
      }
    } // Generate the iframe
    // @param {Object} conf : widget configuration


    function generateIframe(id, conf) {
      if (conf.iframeGenerated) return;
      conf.iframeGenerated = true; // Get iframe container

      var container = document.getElementById(id);

      if (conf.options.popin) {
        if (container) // Remove the div with the config to set it in the real root of the iframe
          container.parentNode.removeChild(container);
        addPopinStyleOnce();
        container = document.createElement('div');
        container.setAttribute('id', id);
        container.setAttribute('class', 'swn-lp-popin swn-lp-popin-closed');
        container.addEventListener('click', function (e) {
          if (e.target !== e.currentTarget) return; //make sure the click is really on the popin background, not coming from some event bubbling

          closeWidget(e.target.id);
        });
        document.body.insertBefore(container, document.body.firstChild);
      } else container.classList.add('swn-lp-ctn'); // creates iframe and insert it


      var ifr = document.createElement('iframe');
      ifr.setAttribute('id', IFRAME_ID_PREFIX + id);
      ifr.setAttribute('name', id);
      ifr.setAttribute('width', '100%');
      ifr.setAttribute('allowtransparency', 'true');
      ifr.setAttribute('class', 'swn-lp-ifr swn-lp-ctn-hide');
      ifr.setAttribute('scrolling', 'no');
      ifr.setAttribute('title', conf.options.iframeTitle || getI18ntText('IFRAMETITLE', conf.options.lang));
      ifr.src = Ifr_URL;
      container.appendChild(ifr);
      loadLp(ifr);
      if (forceOpen || conf.options.autoOpen !== false) swnShowLp(id, null, true);
    } // Set tracking id
    // @param {String} tid : the traking id


    function setTid(tid, region) {
      var px = document.createElement('img'),
          region = region ? region + '-' : '';
      px.src = TrkTid_URL.replace('{{region}}-', region) + tid;
      px.style.display = 'none';
      document.body.appendChild(px);
    } // Set close callback
    // @param {function} callback : close callback


    function setLpCloseCallback(callback) {
      if (typeof callback === 'function') widgetLocalData.closeCallback = callback;
    } // Set server tracking script
    // @param {String} script : tracking script


    function addScript(script) {
      var scriptTag = document.createElement('script');
      scriptTag.setAttribute('type', 'text/javascript');
      scriptTag.innerHTML = 'try{ ' + script + '} catch(err){console.error(err);}';
      document.body.appendChild(scriptTag);
    }

    function addStyleNode(style, id) {
      // Don't add the style if it's already on the page
      if (id && document.getElementById(id) != null) return;
      var iframeStyleTag = document.createElement('style');
      iframeStyleTag.innerHTML = style;
      if (id) iframeStyleTag.setAttribute('id', id);
      document.head.appendChild(iframeStyleTag);
    }

    function getDisplayedHeight(container) {
      var viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
          positionFromTop = container.getBoundingClientRect().top;
      return viewportHeight - positionFromTop;
    }

    function getUserLoc(id, auto) {
      var iframe = document.getElementById(IFRAME_ID_PREFIX + id);

      if (navigator.geolocation) {
        if (getConf(id).options.disableBrowserAutoGeolocation && auto) return;

        function geoSuccess(position) {
          sendMessage(iframe.contentWindow, {
            action: 'lp:setLocByLongLat',
            lng: position.coords.longitude,
            lat: position.coords.latitude,
            auto: auto
          });
        }

        function geoError(error) {
          if (!auto) getServerLoc(iframe);
        }

        navigator.geolocation.getCurrentPosition(geoSuccess, geoError, {
          timeout: 1e4
        });
      } else {
        if (!auto) getServerLoc(iframe);
      }
    }

    function getServerLoc(iframe) {
      sendMessage(iframe.contentWindow, {
        action: 'lp:serverGeoloc'
      });
    }

    function showButtonsListener(event) {
      event.stopPropagation();
      event.preventDefault();
      var rootId = getLpDataAttribute(event.currentTarget, 'widgetId');
      window.swnShowLp(rootId, event.currentTarget, false);

      if (getConf(rootId).options.scrollToWidget) {
        var ifr = document.getElementById(IFRAME_ID_PREFIX + rootId);
        if (ifr) ifr.scrollIntoView({
          behavior: 'smooth'
        });
      }

      return false;
    }

    function showButtonsListenerKeyDown(event) {
      if (event.keyCode !== 13) return true;
      showButtonsListener(event);
    }

    function closeWidget(id) {
      if (widgetLocalData.instancesData[id].lpConfig == null) return;
      var lpIframe = document.querySelector('#' + id + ' iframe');
      if (lpIframe.classList.contains('swn-lp-ctn-hide')) return;
      lpIframe.classList.add('swn-lp-ctn-hide');

      if (widgetLocalData.instancesData[id].lpConfig.options.popin) {
        lpIframe.parentNode.classList.add('swn-lp-popin-closed'); // try to get document.body but we might have a chance it's not initialised yet so also use a fallback

        var body = document.body || document.getElementsByTagName('body');
        body.classList.remove('swn-lp-popin-open');
      }

      if (widgetLocalData.instancesData[id].buttons != null) widgetLocalData.instancesData[id].buttons.forEach(function (btn) {
        btn.classList.remove('swn-wtb-btn-open');
      });
      if (typeof widgetLocalData.closeCallback === 'function') widgetLocalData.closeCallback(id);
    }

    function bindOpenButton(element, id) {
      element.setAttribute('data-widget-id', id);
      element.classList.add('swn-wtb-btn-enabled');
      element.classList.remove('swn-wtb-btn-disabled');
      element.addEventListener('click', showButtonsListener, false);
      element.addEventListener('touchend', showButtonsListener, false);
      element.addEventListener('keydown', showButtonsListenerKeyDown, false); // Add the open button class if the widget is open

      var lpIframe = document.querySelector('#' + id + ' iframe');
      if (lpIframe && !lpIframe.classList.contains('swn-lp-ctn-hide')) element.classList.add('swn-wtb-btn-open');
    }

    function unbindOpenButton(element, id) {
      element.removeAttribute('data-widget-id');
      element.classList.remove('swn-wtb-btn-enabled');
      element.classList.remove('swn-wtb-btn-disabled');
      element.classList.remove('swn-wtb-btn-open');
      element.removeEventListener('click', showButtonsListener, false);
      element.removeEventListener('touchend', showButtonsListener, false);
      element.addEventListener('keydown', showButtonsListenerKeyDown, false);
    }

    function addPopinStyleOnce() {
      if (popinStyleAdded) return;
      popinStyleAdded = true;
      var iframeStyle = document.createElement('style');
      iframeStyle.innerHTML = "\n      @media screen and (min-width: 631px) {\n        .swn-lp-popin {\n          z-index:2147483647;\n          position: fixed;\n          top: 0;\n          left: 0;\n          width: 100%;\n          height: 100vh;\n          background-color: rgba(0,0,0,0.5);\n          display: -webkit-box;\n          display: -webkit-flex;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-pack: center;\n          -webkit-justify-content: center;\n          -ms-flex-pack: center;\n          justify-content: center;\n          -webkit-box-align: center;\n          -webkit-align-items: center;\n          -ms-flex-align: center;\n          align-items: center;\n        }\n        .swn-lp-popin iframe{\n          width:90%;\n          max-width:1200px;\n          min-width: 631px;\n          max-height: 95vh;\n        }\n      }\n      .swn-lp-popin iframe.swn-lp-ctn-hide{\n        display:none !important;\n      }\n      .swn-lp-popin-closed {\n        display: none;\n      }";
      document.head.appendChild(iframeStyle);
    }

    function serializeConfPattern(pattern) {
      var conf = getNewOptionObject();

      for (var attr in pattern) {
        var value = pattern[attr]; // Cast in string if a boolean is passed because data-attributes are strings

        if (value != null && typeof value !== 'string') value = value.toString();
        var prefix = attr.split('-')[0],
            target;

        if (prefix === 'locale') {
          // If the prefix is 'locale', we need to put the value on another object
          var lang = attr.split('-')[1]; // Remove the prefix part to process le rest like any regular parameter

          attr = attr.replace('locale-' + lang + '-', '');
          prefix = attr.split('-')[0]; // We need to unify the lang (after the replacement of course) to avoid issues with case

          lang = lang.toLowerCase().replace('_', '-');
          target = conf.locale[lang] = conf.locale[lang] || getNewOptionObject();
        } else target = conf; // Set the style attribute on the style Object


        if (Object.keys(target.style).indexOf(prefix) !== -1) {
          // Only button-mode and store-by-page are in the wrong way so lets put them in the right one
          if (attr.match(/header-logo|header-label|product-label-pattern|button-mode/)) target[toLowerCamelCase(attr)] = value;else {
            if (prefix === 'iw') {
              // infowindow is specific since the prefix is 'iw-store'
              prefix = 'infowindow';
              attr = attr.replace('iw-store-', '');
            } else attr = attr.replace(prefix + '-', '');

            target.style[prefix][toLowerCamelCase(attr)] = value;
          }
        } else {
          if (value === 'true') value = true;else if (value == 'false') value = false;
          target[toLowerCamelCase(attr)] = value;
        }
      }

      return conf;
    }

    function toLowerCamelCase(str) {
      return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
        return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
      }).replace(/\s+|-+/g, '');
    } // generates a string for width & height HTML attributes with dimensions for button image


    function getSizeAttributes(options) {
      var mobile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var res = '',
          suffix = mobile ? 'Mobile' : '';
      if (options['imgWidth' + suffix]) res += 'width="' + options['imgWidth' + suffix] + '" ';
      if (options['imgHeight' + suffix]) res += 'height="' + options['imgHeight' + suffix] + '" ';
      return res;
    }

    function generateButton(options, confId) {
      removeEmbeddedButton(confId);
      addButtonStyle(options.style.button, confId);
      var button = document.createElement('div');
      button.setAttribute('widget-id', confId);
      button.setAttribute('class', 'swn-wtb-btn ' + confId);
      button.setAttribute('id', 'swn-lp-embedded-button-' + confId);
      button.setAttribute('tabindex', '0'); // Selectable througt tab for A11Y

      if (options.style.button.imgUrl) {
        var dims = '',
            mobileDims = '';

        if (options.style.button.imgUrl.slice(-4) === '.svg') {
          dims = getSizeAttributes(options.style.button);
          mobileDims = getSizeAttributes(options.style.button, true);
        }

        button.innerHTML = '<img class="swn-lp-embedded-button-img-desktop" src="' + options.style.button.imgUrl + '"' + dims + '/><img class="swn-lp-embedded-button-img-mobile" src="' + options.style.button.imgUrlMobile + '"' + mobileDims + '/>';
      } else {
        var icon = '<i class="swn-lp-cart"></i>';
        button.innerHTML = '<span>' + options.style.button.text + '</span>';
        if (options.style.button.iconSide === 'left') button.innerHTML = icon + button.innerHTML;else if (options.style.button.iconSide === 'right') button.innerHTML = button.innerHTML + icon;
      }

      document.body.insertBefore(button, document.body.firstChild);
      return button;
    }

    function removeEmbeddedButton(confId) {
      var stylesheet = document.getElementById('swn-lp-embedded-button-style-' + confId);
      if (stylesheet) stylesheet.parentNode.removeChild(stylesheet);
      var btn = document.getElementById('swn-lp-embedded-button-' + confId);
      if (btn) btn.parentNode.removeChild(btn);
    }

    function addButtonStyle(style, confId) {
      setDefaultButtonStyleValues(style);
      var positionX, positionY;

      switch (style.positionX) {
        case 'left':
          positionX = 'left:0';
          break;

        case 'middle':
          positionX = 'left:50%; transform: translate(-50%, 0);';
          break;

        case 'right':
          positionX = 'right:0';
          break;

        default:
          positionX = style.positionX;
      }

      switch (style.positionY) {
        case 'top':
          positionY = 'top:0';
          break;

        case 'middle':
          positionY = 'top:50%; transform: translate(0, -50%);';
          break;

        case 'bottom':
          positionY = 'bottom:0';
          break;

        default:
          positionY = style.positionY;
      }

      var iframeStyle = document.createElement('style'); // Add id to style sheet to identify it and remove it on the studio to avoid style sheet stacking

      iframeStyle.setAttribute('id', 'swn-lp-embedded-button-style-' + confId);
      iframeStyle.innerHTML = "\n      @font-face {\n        font-family: 'swn-lp-cart';\n        src: url('//prd-swaven-widgets.s3-eu-west-1.amazonaws.com/lp/fonts/cart.ttf') format('truetype');\n        font-weight: normal;\n        font-style: normal;\n      }\n\n      .".concat(confId, " .swn-lp-cart:before {\n        content: '\\e800';\n        font-family: 'swn-lp-cart' !important;\n        font-style: normal;\n        font-weight: normal;\n        speak: none;\n\n        display: inline-block;\n        text-decoration: inherit;\n        width: 1em;\n        text-align: center;\n        font-variant: normal;\n        text-transform: none;\n        line-height: 1em;\n        -webkit-font-smoothing: antialiased;\n        -moz-osx-font-smoothing: grayscale;\n        transform: rotate(").concat(style.iconRotation, ");\n      }\n\n      .").concat(confId, ".swn-wtb-btn {\n        display: none;\n        margin: 0;\n\t      vertical-align: baseline;\n        z-index: ").concat(style.zIndex, ";\n        position: fixed;\n        ").concat(positionX, ";\n        ").concat(positionY, ";\n        font-size: ").concat(style.fontSize, ";\n        color: #").concat(style.color, ";\n        border: ").concat(style.border, ";\n        background: ").concat(style.bg, ";\n        transition: all ").concat(style.transition, ";\n        padding: ").concat(style.padding, ";\n        border-radius: ").concat(style.borderRadius, ";\n        text-transform: ").concat(style.textTransform, ";\n        user-select: none;\n        cursor: pointer;\n      }\n\n      .").concat(confId, ".swn-wtb-btn.swn-wtb-btn-enabled {\n        display: block;\n      }\n\n      .").concat(confId, ".swn-wtb-btn img {\n        display: block;\n        margin: 0;\n        padding: 0;\n        border: 0;\n        font-size: 100%;\n        font: inherit;\n        vertical-align: baseline;\n      }\n\n      .").concat(confId, ".swn-wtb-btn .swn-lp-embedded-button-img-mobile {\n        display: none;\n      }\n\n      .").concat(confId, ".swn-wtb-btn:hover, .").concat(confId, ".swn-wtb-btn:focus {\n        color: #").concat(style.colorHover, ";\n        background: ").concat(style.bgHover, ";\n        border: ").concat(style.borderHover, ";\n      }\n\n      @media screen and (max-width: ").concat(style.mobileThreshold, "){\n        .").concat(confId, ".swn-wtb-btn {\n          z-index: ").concat(style.zIndexMobile, ";\n        }\n        .").concat(confId, ".swn-wtb-btn .swn-lp-embedded-button-img-mobile {\n          display: block;\n        }\n        .").concat(confId, ".swn-wtb-btn .swn-lp-embedded-button-img-desktop {\n          display: none;\n        }\n        .").concat(confId, ".swn-wtb-btn span {\n           /* hide text only if picto is shown */\n          ").concat(style.iconSide != 'none' ? 'display: none;' : '', "\n        }\n      }\n    ");
      document.head.appendChild(iframeStyle);
    }

    function setDefaultButtonStyleValues(style) {
      style.positionX = style.positionX || 'right';
      style.positionY = style.positionY || 'middle';
      style.text = style.text || '';
      style.fontSize = style.fontSize || '37px';
      style.color = style.color || 'ffffff';
      style.colorHover = style.colorHover || style.color;
      style.bg = style.bg || '#F20100';
      style.bgHover = style.bgHover || 'linear-gradient(to bottom, rgba(242,1,0,1) 0%, rgba(211,3,0,1) 100%)';
      style.transition = style.transition || '0ms';
      style.padding = style.padding || '12px';
      style.borderRadius = style.borderRadius || '0px';
      style.border = style.border || '';
      style.borderHover = style.borderHover || '';
      style.textTransform = style.textTransform || 'inherit';
      style.iconSide = style.iconSide || 'left';
      style.iconRotation = style.iconRotation || '-15deg';
      style.mobileThreshold = style.mobileThreshold || '630px';
      style.zIndex = style.zIndex || '9999';
      style.zIndexMobile = style.zIndexMobile || style.zIndex;
      if (style.imgUrl && !style.imgUrlMobile) style.imgUrlMobile = style.imgUrl;
    }

    function clone(obj) {
      var newObj = obj instanceof Array ? [] : {};

      for (var key in obj) {
        var value = obj[key];
        if (value && _typeof(value) === 'object') newObj[key] = clone(value);else newObj[key] = value;
      }

      return newObj;
    }

    function needToFullyReload(newConf, currentConf) {
      for (var key in newConf) {
        var val = newConf[key];

        if (_typeof(val) === 'object') {
          if (key !== 'style' && needToFullyReload(val, currentConf[key])) return true;
        } else if (['eans', 'range', 'defaultPrd'].indexOf(key) == -1 && currentConf[key] !== val) return true;
      }

      return false;
    }

    function updateIframe(id, newConf) {
      var data = {
        action: 'lp:update',
        data: newConf
      },
          iframe = document.getElementById(IFRAME_ID_PREFIX + id);
      if (widgetLocalData.instancesData[id].iframeReady) sendMessage(iframe.contentWindow, data);else {
        if (!waitingPostMessage[id]) waitingPostMessage[id] = [];
        waitingPostMessage[id].push({
          target: iframe.contentWindow,
          data: data
        });
      }
    }

    function reloadIframe(id, newConf) {
      widgetLocalData.instancesData[id].iframeReady = false;
      var iframe = document.getElementById(IFRAME_ID_PREFIX + id); // Hide the frame until it's ready to avoid showing the ugly transition of styles

      iframe.style.display = 'none';
      iframe.src = iframe.src;
      loadLp(iframe);
    }

    function replaceObject(oldObj, newObj) {
      Object.keys(newObj).forEach(function (key) {
        if (_typeof(newObj[key]) === 'object') replaceObject(oldObj[key], newObj[key]);else oldObj[key] = newObj[key];
      });
    }

    function objectEquals(obj1, obj2) {
      var obj1Keys = Object.keys(obj1);

      for (var i = 0; i < obj1Keys.length; i++) {
        var key = obj1Keys[i];

        if (obj1[key] == null) {
          if (obj2[key] != null) return false;
        } else if (_typeof(obj1[key]) === 'object') {
          if (!objectEquals(obj1[key], obj2[key])) return false;
        } else if (obj1[key] !== obj2[key]) {
          return false;
        }
      }

      return true;
    }

    function getNewOptionObject() {
      return {
        style: {
          global: {},
          header: {},
          locbar: {},
          product: {},
          productlist: {},
          store: {},
          storelist: {},
          infowindow: {},
          loader: {},
          button: {}
        },
        locale: {}
      };
    }

    window.swnUnloadAllLP = function () {
      widgetLocalData.clientCallback = null;
      widgetLocalData.urlConf = {};
      pageId = uuid();
      Object.keys(widgetLocalData.instancesData).forEach(function (id) {
        unloadOne(id);
      });
      document.removeEventListener('scroll', pageScrolled);
      var fullscreenStyle = document.getElementById('swn-lp-mobile-fullscreen-style');
      if (fullscreenStyle) fullscreenStyle.parentNode.removeChild(fullscreenStyle);
    };

    function unloadOne(id) {
      // unbind buttons
      if (widgetLocalData.instancesData[id].buttons != null) {
        widgetLocalData.instancesData[id].buttons.forEach(function (btn) {
          unbindOpenButton(btn, id);
        });
        removeEmbeddedButton(id);
      }

      var iframe = document.getElementById(IFRAME_ID_PREFIX + id),
          elementToRemove = iframe; // If it's a popin we need to remove the container

      if (widgetLocalData.instancesData[id].lpConfig.options.popin) elementToRemove = iframe.parentNode;
      elementToRemove.parentNode.removeChild(elementToRemove);
      delete widgetLocalData.instancesData[id];
      delete widgetLocalData.originalConfs[id];
      delete waitingPostMessage[id];

      if (btnWatcherItvs[id]) {
        clearInterval(btnWatcherItvs[id]);
        delete btnWatcherItvs[id];
      }
    }

    function startBtnWatcher(querySelectors, confId) {
      btnWatcherItvs[confId] = setInterval(function () {
        var widgetData = widgetLocalData.instancesData[confId],
            availabilityBuffer = [];
        querySelectors.forEach(function (querySelector) {
          document.querySelectorAll(querySelector).forEach(function (btn) {
            if (widgetData.buttons.indexOf(btn) === -1) {
              widgetLocalData.instancesData[confId].buttons.push(btn); // Only check availabilities if the widget is not auto open an the feature is enabled in the conf

              if (!widgetData.wtbConf.avprdonly || widgetData.lpConfig.options.autoOpen) bindOpenButton(btn, confId);else {
                var scope = getAvailabilityScopeFromBtn(btn, confId, widgetData.lpConfig.options);
                availabilityBuffer[scope] = availabilityBuffer[scope] || [];
                availabilityBuffer[scope].push(btn);
              }
            }
          });
        });
        flushAvailabilityBuffer(availabilityBuffer, widgetData.wtbConf, confId);
      }, 1000);
    }

    function initCookieUsageNotification(lang, theme) {
      lang = lang || 'en-GB';
      theme = theme || 'dark';
      if (cookieInitiated) return;
      cookieInitiated = true; // Everything is !important to avoid being overridden by client style (with possible !important)

      var cookieDivStyle = ".swn-cookies-banner {\n      position: fixed !important;\n      bottom: 0px !important;\n      left: 0px !important;\n      z-index: 100001;\n      min-height: 50px !important;\n      display: -webkit-box !important;\n      display: -ms-flexbox !important;\n      display: flex !important;\n      width: 100% !important;\n      -webkit-box-orient: vertical !important;\n      -webkit-box-direction: normal !important;\n      -ms-flex-direction: column !important;\n      flex-direction: column !important;\n      font-family: sans-serif !important;\n      -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n      align-items: center !important;\n      -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n      justify-content: center !important;\n      padding: 20px 40px 20px 40px !important;\n      box-sizing: border-box !important;\n    }\n    .swn-cookies-banner span {\n      position: absolute !important;\n      top: 10px !important;\n      font-size: 20px !important;\n      right: 10px !important;\n      font-family: monospace !important;\n      cursor: pointer !important;\n    }\n    .swn-cookies-banner .swn-cookies-txt {\n      margin-bottom: 10px !important;\n      font-size: 17px !important;\n      width: 100% !important;\n    }\n    .swn-cookies-banner .swn-cookies-txt a {\n      color: inherit !important;\n    }\n    .swn-cookies-banner .swn-cookies-ok {\n      padding: 5px 20px !important;\n      font-size: 19px !important;\n      background: #cccccc !important;\n      display: table !important;\n      color: #000000 !important;\n      cursor: pointer !important;\n    }\n    .swn-cookies-banner.light {\n      color: #000000;\n      background: rgba(255,255,255,0.7);\n    }\n    .swn-cookies-banner.dark {\n      color: #ffffff;\n      background: rgba(0,0,0,0.7);\n    }\n    ";
      addStyleNode(cookieDivStyle, 'swn-cookie-banner-style'); // Get the langage and generate the cookie notification banner

      var cookieDiv = document.createElement('div');
      cookieDiv.classList.add('swn-cookies-banner');
      cookieDiv.classList.add(theme);
      cookieDiv.innerHTML = '<span>&#10006;</span><div class="swn-cookies-txt">' + getCookieText('COOKIESTXT', lang) + ' <a target="_blank" href="' + getCookieText('COOKIESLINK', lang) + '">' + getCookieText('COOKIESMORE', lang) + '</a></div><div class="swn-cookies-ok">' + getCookieText('COOKIESOK', lang) + '</div>';
      var body = document.body || document.getElementsByTagName('body')[0];
      body.insertBefore(cookieDiv, body.firstChild);

      function removeCookieBanner() {
        cookieDiv.parentNode.removeChild(cookieDiv);
      }

      function setCookiesOk() {
        removeCookieBanner();
        setCookie('swncookieok', '1', 365);
      }

      var closeBtn = cookieDiv.querySelector('span');
      closeBtn.addEventListener('click', removeCookieBanner);
      closeBtn.addEventListener('touchend', removeCookieBanner);
      var okBtn = cookieDiv.querySelector('.swn-cookies-ok');
      okBtn.addEventListener('click', setCookiesOk);
      okBtn.addEventListener('touchend', setCookiesOk);
    }

    function getCookieText(text, lang) {
      return cookieCustomTxts[text] || getI18ntText(text, lang);
    }

    function getI18ntText(text, lang) {
      lang = (lang || 'en-gb').substr(0, 2).toLowerCase();
      var txt;
      if (i18nTxts[lang]) txt = i18nTxts[lang][text];
      return txt || i18nTxts.en[text];
    }

    function getCookie(name) {
      var re = new RegExp(name + '=([^;]+)'),
          value = re.exec(document.cookie);
      return value != null ? unescape(value[1]) : null;
    }

    function setCookie(name, value, duration) {
      var expires = '';

      if (duration) {
        var d = new Date();
        d.setTime(d.getTime() + duration * 24 * 60 * 60 * 1000);
        expires = ';expires=' + d.toUTCString();
      }

      document.cookie = name + '=' + value + expires + ';path=/';
    }

    window.lpOneTimeExecutedJS = window.lpOneTimeExecutedJS || false;

    if (window.lpOneTimeExecutedJS === false) {
      window.lpOneTimeExecutedJS = true; // Attach postMessage handler

      window.addEventListener('message', receiveMessage, false);
      var lpStyle = ".swn-lp-ifr{\n      display:block;\n      position: relative;\n      border:none;\n      width: 1px; /* fix safari mobile issue https://www.spacevatican.org/2015/4/7/on-mobile-safari-and-iframes/ */\n      min-width: 100%;\n      height: 600px;\n      -webkit-transition:height 250ms ease-in-out;\n      -moz-transition:height 250ms ease-in-out;\n      -ms-transition:height 250ms ease-in-out;\n      -o-transition:height 250ms ease-in-out;\n      transition:height 250ms ease-in-out;\n    }\n    body.swn-lp-mobile .swn-lp-ifr{\n      height: 100%;\n      max-height: none;\n    }\n    .swn-lp-ctn-hide{\n      height: 0px !important;\n      overflow: hidden;\n    }";
      addStyleNode(lpStyle);
      setUrlConf();
    }
  }();
}();